export default __webpack_public_path__ + "static/media/jm_logo.80e5a26c.png";